var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "mt" },
    [
      _c("w-card-title", [
        _vm._v(_vm._s(_vm.$ct("external-mail-server-settings"))),
      ]),
      _c(
        "w-card-content",
        [
          _vm.loggedInWithGoogle
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { "no-margin": "", center: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "api-info", style: { flexGrow: 1 } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$ct("logged-in-with-google-api-as", {
                                    email: _vm.gmailAddress,
                                  })
                                )
                              ),
                            ]
                          ),
                          _c(
                            "w-button",
                            {
                              staticClass: "danger",
                              attrs: { icon: ["fab", "google"] },
                              on: {
                                click: function ($event) {
                                  return _vm.gmailLogout()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("gmail-logout")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.loggedInWithMicrosoft
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { "no-margin": "", center: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "api-info", style: { flexGrow: 1 } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$ct("logged-in-with-microsoft-api-as", {
                                    email: _vm.microsoftAddress,
                                  })
                                )
                              ),
                            ]
                          ),
                          _c(
                            "w-button",
                            {
                              staticClass: "danger",
                              attrs: { icon: ["fab", "microsoft"] },
                              on: {
                                click: function ($event) {
                                  return _vm.microsoftLogout()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("microsoft-logout")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "8", "no-margin": "" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("mailUsername"),
                                },
                                model: {
                                  value: _vm.mailSettings.Email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.mailSettings, "Email", $$v)
                                  },
                                  expression: "mailSettings.Email",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-checkbox", {
                                attrs: { label: _vm.$ct("use-ssl") },
                                model: {
                                  value: _vm.useSsl,
                                  callback: function ($$v) {
                                    _vm.useSsl = $$v
                                  },
                                  expression: "useSsl",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  label: _vm.$ct("skip-certificate-validation"),
                                },
                                model: {
                                  value: _vm.insecureSkipVerify,
                                  callback: function ($$v) {
                                    _vm.insecureSkipVerify = $$v
                                  },
                                  expression: "insecureSkipVerify",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "8", md: "10" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("mailServer"),
                                },
                                model: {
                                  value: _vm.emailServer,
                                  callback: function ($$v) {
                                    _vm.emailServer = $$v
                                  },
                                  expression: "emailServer",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "4", md: "2" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  decimals: 0,
                                  "calculated-decimals": 0,
                                  fancy: "",
                                  label: _vm.$ct("mailServerPort"),
                                },
                                model: {
                                  value: _vm.emailServerPort,
                                  callback: function ($$v) {
                                    _vm.emailServerPort = $$v
                                  },
                                  expression: "emailServerPort",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.serverWarning
                            ? _c("w-col", [
                                _c("span", { staticClass: "warning" }, [
                                  _vm._v(_vm._s(_vm.serverWarning)),
                                ]),
                              ])
                            : _vm._e(),
                          _c(
                            "w-col",
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  password: !_vm.showPassword,
                                  icon: "eye",
                                  label: _vm.$ct("mailPassword"),
                                  autocomplete: "new-password",
                                },
                                on: {
                                  "icon-click": function ($event) {
                                    _vm.showPassword = !_vm.showPassword
                                  },
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function ($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "4", "no-margin": "" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c("w-col", [
                            _c(
                              "button",
                              {
                                staticClass: "social-login google-login-button",
                                on: {
                                  click: function ($event) {
                                    _vm.startAutoConfig = true
                                  },
                                },
                              },
                              [
                                _c("w-fa", {
                                  staticClass: "ml",
                                  attrs: { icon: "cog" },
                                }),
                                _c("w-spacer"),
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("auto-config")) + " "
                                ),
                                _c("w-spacer"),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c("w-col", [
                            _c(
                              "button",
                              {
                                staticClass: "social-login google-login-button",
                                on: {
                                  click: function ($event) {
                                    return _vm.gmailLogin()
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "google-logo",
                                  attrs: {
                                    alt: "Google logo",
                                    src: require("@/assets/img/btn_google_light_normal.svg"),
                                  },
                                }),
                                _c("w-spacer"),
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("gmail-login")) + " "
                                ),
                                _c("w-spacer"),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c("w-col", [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "social-login microsoft-login-button",
                                on: {
                                  click: function ($event) {
                                    return _vm.microsoftLogin()
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "microsoft-logo",
                                  attrs: {
                                    src: require("@/assets/img/ms-logo.svg"),
                                    alt: "Microsoft logo",
                                  },
                                }),
                                _c("w-spacer"),
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("microsoft-login")) + " "
                                ),
                                _c("w-spacer"),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _vm.showActions
        ? _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.testDialog = true
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.startAutoConfig,
            callback: function ($$v) {
              _vm.startAutoConfig = $$v
            },
            expression: "startAutoConfig",
          },
        },
        [
          _c("mail-auto-config", {
            on: {
              save: _vm.saveAutoConfig,
              close: function ($event) {
                _vm.startAutoConfig = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.testDialog,
            callback: function ($$v) {
              _vm.testDialog = $$v
            },
            expression: "testDialog",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$t("common.info")))]),
              _c("w-card-content", [
                _vm._v(_vm._s(_vm.$ct("testEmailBeforeSafe"))),
              ]),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.sending },
                      on: {
                        click: function ($event) {
                          return _vm.save(false)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.no")) + " ")]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.sending },
                      on: {
                        click: function ($event) {
                          return _vm.save(true)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.yes")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }